<template>
    <v-toolbar dense dark app clipped-left>
        <v-toolbar-title>GDS</v-toolbar-title>
        <div id="toolbar--search">
            <v-text-field v-model.number="code" :disabled="searching" :mask="validation.mask.demandCode" @keydown.native.enter="search" hide-details placeholder="Busque pelo código da demanda"></v-text-field>
            <v-btn icon class="ma-0" @click="search" v-if="!searching">
                <v-icon color="grey darken-4">search</v-icon>
            </v-btn>
            <v-progress-circular v-if="searching" :size="24" indeterminate color="primary"></v-progress-circular>
        </div>
        <v-spacer></v-spacer>
        <v-btn flat :to="{name: 'dashboard'}"> {{ $t('label.dashboard') }}</v-btn>
        <v-btn flat :to="{name: 'demandIndex'}"> {{ $t('label.demands') }}</v-btn>
        <v-btn flat :to="{name: 'contractIndex'}" v-if="isAdmin"> {{ $t('label.contracts') }}</v-btn>
        <v-btn flat :to="{name: 'systemIndex'}"> {{ $t('label.systems') }}</v-btn>
        <v-btn flat :to="{name: 'personIndex'}"> {{ $t('label.persons') }}</v-btn>
        <v-btn flat :to="{name: 'demandOwnerSubstitutionIndex'}"> {{ $t('label.substitutions') }}</v-btn>

        <v-menu offset-y>
            <v-btn dark slot="activator">{{ $t('label.types') }}</v-btn>
            <v-list>
                <v-list-tile :to="{name: 'typeApproverIndex'}">
                    <v-list-tile-title>{{ $t('label.approvers') }}</v-list-tile-title>
                </v-list-tile>
                <v-list-tile :to="{name: 'typeDemandIndex'}">
                    <v-list-tile-title>{{ $t('label.demands') }}</v-list-tile-title>
                </v-list-tile>
            </v-list>
        </v-menu>

        <app-profile></app-profile>
    </v-toolbar>
</template>

<style lang="stylus">
    #toolbar--search
        margin-left 36px
        background-color white
        width 261px

        button, .progress-circular
            float right

        .progress-circular
            margin-top 6px
            color rgba(0,0,0,0.87)
            margin-right 9px

        .input-group
            width 225px
            float left

            .input-group__input
                background-color white

                ::placeholder
                    color rgba(0,0,0,0.5)

            .input-group__details
                display none
</style>


<script>
import validation from '@/helpers/validation';
// import constants from '@/helpers/constants';
import Profile from './Profile';

export default {
    data() {
        return {
            code: '',
            searching: false,
            validation,
        };
    },
    computed: {
        isAdmin() {
            return this.$store.getters.isAdmin;
        },
    },
    components: {
        appProfile: Profile,
    },

    methods: {
        async search() {
            this.searching = true;
            await this.$store.dispatch('findDemandByCode', { code: this.code });
            const demand = this.$store.getters.demand;
            if (demand.code === this.code) {
                this.code = '';
                console.log("cdIdentificadorFornecedor = " + demand.supplier.id);
                this.$router.push({ name: 'demandEdit', params: { id: demand.id } });
            } else {
                this.$store.dispatch('showWarning', this.$t('message.info.demandNotFound'));
            }

            this.searching = false;
        },
    },
};
</script>


// WEBPACK FOOTER //
// src/components/shared/Header.vue